import isMobile from 'ismobilejs';
import kebabcase from 'lodash.kebabcase';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import formFieldSubmitArrow from '../../images/svg/form-field-submit-arrow.svg';
import formFieldValidIcon from '../../images/svg/form-field-valid.svg';

class FormFieldInputComponent extends Component {
    static propTypes = {
        assignRef: PropTypes.func.isRequired,
        isFormSubmitted: PropTypes.bool.isRequired,
        linkColor: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        onFieldSubmit: PropTypes.func.isRequired,
        placeholder: PropTypes.string,
        submittedFieldValue: PropTypes.string,
        type: PropTypes.string.isRequired,
    };

    state = {
        hasError: false,
        inputValue: this.props.isFormSubmitted ? this.props.submittedFieldValue : '',
        invalidMessage: '',
        isButtonHovered: false,
        isInputFocused: false,
        isSubmitted: this.props.isFormSubmitted,
    };

    inputRef = React.createRef();
    isValidating = false;

    styles = {
        button: {
            color: '#fff',
            backgroundColor: this.props.linkColor,
            borderColor: this.props.linkColor,
        },
        buttonHover: {
            color: '#fff',
            backgroundColor: this.props.linkColor,
            borderColor: this.props.linkColor,
        },
        input: {
            boxShadow: 'none',
            resize: 'none',
        },
        inputFocus: {
            borderColor: this.props.linkColor,
            outline: 0,
        },
        inputFocusValidated: {
            backgroundColor: '#F4F6F8',
            color: '#9BA4B3',
        },
    };

    validateField = (e) => {
        e.preventDefault();

        if (this.isValidating) {
            return;
        }

        this.isValidating = true;

        this.props.onFieldSubmit({
            value: this.state.inputValue.trim(),
            onValidationSuccess: () => {
                this.isValidating = false;
                this.setState({ hasError: false, invalidMessage: '', isSubmitted: true });
            },
            onValidationError: (error) => {
                this.isValidating = false;
                this.setState({ hasError: true, invalidMessage: error || 'An error occurred.' });
            },
        });
    };

    onChange = (e) => {
        e.preventDefault();
        this.setState({ hasError: false, inputValue: e.target.value });
    };

    toggleFocus = (isInputFocused) => {
        this.setState({
            isInputFocused,
        });
    };

    getInputStyle = () => {
        const isInputFocusedNotYetValidated =
            this.state.isInputFocused && !this.state.hasError && !this.state.isSubmitted;

        return {
            ...this.styles.input,
            ...(isInputFocusedNotYetValidated && this.styles.inputFocus),
            ...(this.state.isSubmitted ? this.styles.inputFocusValidated : { paddingRight: '12px' }),
        };
    };

    getSubmittedFeedback = ({ id }) => {
        return (
            <div className={`input-validation${this.state.isSubmitted ? ' input-validation--validated' : ''}`}>
                <img
                    className="form-control-feedback"
                    aria-hidden="true"
                    src={formFieldValidIcon}
                    alt="successful validation"
                />
                <span id={id} className="sr-only">
                    (success)
                </span>
            </div>
        );
    };

    getSubmitButton = () => {
        return (
            <span
                className="input-group-btn"
                onMouseEnter={() => this.toggleHover(true)}
                onMouseLeave={() => this.toggleHover(false)}
            >
                <button
                    className="btn"
                    style={this.state.isButtonHovered ? this.styles.buttonHover : this.styles.button}
                    type="button"
                    onClick={this.validateField}
                >
                    {' '}
                    <img
                        style={{ maxWidth: 'none' }}
                        className="btn__submit-arrow-icon"
                        src={formFieldSubmitArrow}
                        alt="submit"
                    />{' '}
                </button>
            </span>
        );
    };

    onKeyPress = (e) => {
        if (!isMobile().any && !e.shiftKey && e.key === 'Enter') {
            this.validateField(e);
        }
    };

    toggleHover = (isButtonHovered) => {
        this.setState({
            isButtonHovered,
        });
    };

    render() {
        const { label, name, placeholder, type } = this.props;
        const isSubmitted = this.state.isSubmitted;
        const isReadOnly = this.isValidating || isSubmitted;

        const inputAttrs = {
            id: kebabcase(name),
            describedBy: kebabcase(`${name}-status`),
        };

        return (
            <div className={`form-group has-feedback${this.state.hasError ? ' has-error' : ''}`}>
                <label htmlFor={inputAttrs.id} className="control-label">
                    {label}
                </label>
                <div {...(isSubmitted && { className: 'input-group--validated' })}>
                    <div {...(!isSubmitted && { className: 'input-group' })}>
                        <input
                            id={inputAttrs.id}
                            aria-describedby={inputAttrs.describedBy}
                            className="form-control"
                            name={name}
                            onBlur={() => this.toggleFocus(false)}
                            onChange={this.onChange}
                            onFocus={() => this.toggleFocus(true)}
                            onKeyPress={this.onKeyPress}
                            placeholder={placeholder}
                            readOnly={isReadOnly}
                            ref={(reference) => {
                                this.inputRef = reference;
                                this.props.assignRef(this.inputRef);
                            }}
                            required
                            style={this.getInputStyle()}
                            type={type}
                            value={this.state.inputValue}
                        />
                        {!isSubmitted && this.getSubmitButton()}
                    </div>
                    {this.getSubmittedFeedback({ id: inputAttrs.describedBy })}
                </div>
                <span className={`help-block${this.state.hasError ? ' help-block--visible' : ''}`}>
                    {this.state.invalidMessage}
                </span>
            </div>
        );
    }
}

export default connect(
    ({ config: { colors } }) => ({
        linkColor: `#${colors.linkColor}`,
    }),
    undefined,
    undefined,
    { forwardRef: true },
)(FormFieldInputComponent);
